<div *ngIf="dataLoaded == false" class="d-flex justify-content-center">
  <div class="spinner-border text-success" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div class="container">
  <div class="container-fluid" *ngIf="dataLoaded">
    <div class="card">
      <h4 class="card-header">Yeni Talep Oluştur</h4>
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="row">
            <!-- Sol sütun -->
            <div class="col-md-6">


              <div class="form-group">
                <label for="status">Kayıt Tipileri (Zorunlu)</label>
                <select class="form-control" formControlName="cihazturid" (change)="changeCity($event)">
                  <option value="">Kayıt Tipi Seçiniz</option>
                  <option *ngFor="let suit of kayitTurModels" value="{{ suit.Id }}">{{ suit.Name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="text">Konu (Zorunlu)</label>
                <input type="text" formControlName="konu" class="form-control" />
              </div>

              <div class="form-group">
                <label for="text">Şikayet (Zorunlu)</label>
                <textarea formControlName="sikayet" class="form-control" rows="3"></textarea>
              </div>

              <div class="form-group">
                <label for="file">Dosya</label>
                <input formControlName="file" id="file" type="file" multiple class="form-control"
                  (change)="onFileChange($event)" />
              </div>
            </div>

            <!-- Sağ sütun -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="musteriAdSoyad">Müşteri Ad Soyad (Zorunlu)</label>
                <input id="musteriAdSoyad" formControlName="musteriAdSoyad" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label for="musteriCepTel">Müşteri Cep Telefonu (Zorunlu)</label>
                <input id="musteriCepTel" formControlName="musteriCepTel" type="tel" class="form-control"
                  (input)="onCepTelInput($event)" maxlength="10" pattern="[0-9]*" autocomplete="off" />
              </div>

              <div class="form-group">
                <label for="musteriEmail">Müşteri Email</label>
                <input id="musteriEmail" formControlName="musteriEmail" type="email" class="form-control" />
              </div>

              <div class="form-group">
                <label for="musteriAdres">Müşteri Adres</label>
                <textarea id="musteriAdres" formControlName="musteriAdres" class="form-control"></textarea>
              </div>
            </div>
          </div>

          <!-- Cihaz bilgileri -->
          <div class="form-group mt-4">
            <label>
              <input type="checkbox" formControlName="cihazEklenecekMi" (change)="toggleCihazEkleme()" />
              Ürün/Cihaz Eklenecek Mi?
            </label>
          </div>

          <div *ngIf="cihazEklenecek" class="mt-3">
            <div formArrayName="cihazlar">
              <div *ngFor="let cihaz of cihazlar.controls; let i = index" [formGroupName]="i" class="border p-3 mb-3">
                
                <div class="form-group form-check mb-2">
                  <input type="checkbox" class="form-check-input" id="manuelGiris{{i}}" [checked]="cihaz.value.manuelGiris" (change)="toggleManuelGiris(i)">
                  <label class="form-check-label" for="manuelGiris{{i}}">Manuel giriş</label>
                </div>

                <div *ngIf="!cihaz.value.manuelGiris">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="markaSelect{{i}}">Marka (Zorunlu)</label>
                      <select id="markaSelect{{i}}" class="form-control" formControlName="markaid" (change)="changeMarka($event, i)">
                        <option value="">Marka Seçiniz</option>
                        <option *ngFor="let suit of markaList" [value]="suit.Id">{{ suit.Name }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="modelSelect{{i}}">Ürün Grubu (Zorunlu)</label>
                      <select id="modelSelect{{i}}" class="form-control" formControlName="modelid" (change)="changeModel($event, i)">
                        <option value="">Ürün Grubu Seçiniz</option>
                        <option *ngFor="let suit of modelList" [value]="suit.Id">{{ suit.Name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div *ngIf="cihaz.value.manuelGiris">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="marka{{i}}">Marka (Zorunlu)</label>
                      <input id="marka{{i}}" formControlName="marka" type="text" class="form-control" />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="model{{i}}">Ürün Grubu (Zorunlu)</label>
                      <input id="model{{i}}" formControlName="model" type="text" class="form-control" />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="serino">Stok Kodu</label>
                  <input id="serino" formControlName="serino" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="barkod">Barkod</label>
                  <input id="barkod" formControlName="barkod" type="text" class="form-control" />
                </div>
                <button type="button" class="btn btn-danger" (click)="removeCihaz(i)">Ürün/Cihaz Kaldır</button>
              </div>
            </div>
            <button type="button" class="btn btn-success" (click)="addCihaz()">Ürün/Cihaz Ekle</button>
          </div>

          <!-- Form gönderme butonu -->
          <div class="form-group text-center mt-3">
            <button [disabled]="loading" class="btn btn-primary">
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Oluştur
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>